const getProductVariant = (item) =>
    item.product_variant || item.variant_detail || item.variant || {};

export const getProductVariantId = (item) => {
    const variant = getProductVariant(item);

    return (
        item.product_variant_id ||
        item.productVariantId ||
        item.variant_id ||
        item.variantId ||
        variant.product_variant_id ||
        variant.variant_id ||
        variant.id ||
        item.product?.product_variant_id ||
        item.id ||
        ""
    );
};

export const getProductPortion = (item) => {
    const variant = getProductVariant(item);

    return (
        item.portion ||
        item.product_portion ||
        item.productPortion ||
        item.selected_portion ||
        item.selectedPortion ||
        variant.portion ||
        variant.product_portion ||
        variant.productPortion ||
        item.product?.portion ||
        ""
    );
};

export const hasPrice = (value) => value !== null && value !== undefined && String(value).trim() !== '';

const getBasePrice = (item) => [
    item.price, item.product_price, item.product_cost, item.final_price, item.finalPrice,
    item.offer_price, item.offerPrice, item.discounted_price, item.product?.price,
].find(hasPrice);

const getSellingPrice = (item) => [
    item.selling_price, item.product_selling_price, item.product?.selling_price,
].find(hasPrice);

export const getProductPrice = (item, selectedPortion) => {
    const source = selectedPortion || item;
    return getSellingPrice(source) ?? getBasePrice(source) ?? 0;
};

export const getOriginalPrice = (item, selectedPortion) => {
    const source = selectedPortion && hasPrice(getSellingPrice(selectedPortion)) ? selectedPortion : item;
    return hasPrice(getSellingPrice(source)) ? getBasePrice(source) : null;
};

export const getProductPortions = (item) => {
    const portions = item.portions ?? item.product?.portions ?? getProductVariant(item).portions;
    return Array.isArray(portions) ? portions.filter((portion) => portion?.portion) : [];
};

export const getProductUnit = (item) =>
    getProductPortion(item) || item.weight_unit || item.unit || item.variant_name || item.packing ||
    item.product?.weight_unit || item.product?.unit || item.product?.packing || "1 kg";
